import styled from 'styled-components'

const StyledCourseTrailerModal = styled.div`
  padding: 32px;
  max-width: 900px;
  max-height: 800px;
  width: 100vh;
  overflow-y: auto;

  .bullet-section {
    margin-top: 35px;
    padding-top: 35px;
    border-top: 1px solid ${({ theme }) => theme.colors.gray[200]};
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 35px;

    h2 {
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.07rem;
      color: ${({ theme }) => theme.colors.gray[500]};
      line-height: unset;
    }

    .course-bullets-container {
      .course-bullets {
        padding: 0;
        margin: 25px 0 0 0;
        display: grid;
        grid-gap: 18px;
        list-style-type: none;

        li {
          display: flex;
          color: ${({ theme }) => theme.colors.gray[700]};
          font-weight: 500;
          line-height: 23px;

          svg {
            height: 24px;
            flex-shrink: 0;
            margin-right: 1rem;
          }
        }
      }
    }
  }

  .course-actions {
    display: flex;
    align-items: center;
    margin-top: 35px;
    justify-content: end;

    .pricing-total {
      font-weight: 500;
      font-size: 20px;
      color: ${({ theme }) => theme.colors.gray[700]};
    }

    .pricing-discount {
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.1px;
      color: ${({ theme }) => theme.colors.gray[400]};
      text-decoration: line-through;
      margin-left: 6px;
    }

    .btn {
      margin-left: 25px;
    }
  }
`

export default StyledCourseTrailerModal
